export function isP2PSessionType(
	sessionType?: Sessions.SessionType | null,
): boolean {
	return sessionType === 'P2P';
}

export function isP2PTranscriptionOnlySessionType(
	sessionType?: Sessions.SessionType | null,
): boolean {
	return sessionType === 'P2P_TRANSCRIPTION_ONLY';
}

export function isP2PLikeSessionType(
	sessionType?: Sessions.SessionType | null,
): boolean {
	return (
		isP2PSessionType(sessionType) ||
		isP2PTranscriptionOnlySessionType(sessionType)
	);
}
